import React from 'react';
import TooltipElement from './tooltipElement';
import { unwrapResult } from '@reduxjs/toolkit';

class FavoriteItemColumnFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updating: false,
      isError: false,
    }
  }

  onClick = () => {
    const { addToFavorites, removeFromFavorites } = this.props.actions;
    const { isFavorite, id } = this.props.row;
    const { isError, updating } = this.state;

    const changeFavoriteStatePromise = isFavorite ? removeFromFavorites : addToFavorites;
    this.setState({ updating: true });
    changeFavoriteStatePromise({ id })
      .then(unwrapResult)
      .then(() => {
        if (isError || updating) this.setState({ isError: false, updating: false })
      })
      .catch(() => {
        if (!isError) this.setState({ isError: true, updating: false })
      });
  };

  render() {
    const { isError, updating } = this.state;

    if (isError) return <span className="glyphicon glyphicon-warning-sign" style={{ color: 'red' }}/>;

    const { isFavorite } = this.props.row;
    const iconClass = isFavorite ? 'star' : 'star-empty';
    const iconText = isFavorite ? 'Remove from favorite' : 'Add to favorite';

    return <TooltipElement
      type="button"
      text={iconText} icon={iconClass}
      disabled={updating}
      onClick={this.onClick}
    />
  }
}

export default FavoriteItemColumnFormatter;



// WEBPACK FOOTER //
// ./src/components/favoriteItemColumnFormatter.js